import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import NewCareFacility from "../components/Admin/CareFacility/NewCareFacility";

function NewCareFacilityPage() {
  return (
    <>

        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={false} />
                </div>
              <div className="content-class">
              <NewCareFacility />
              </div>
              <div className="footer-class">
                  <Footer />
              </div>
            </div>
        </div>
    </>
  );
}

export default NewCareFacilityPage;
